export default __webpack_public_path__ + "static/media/iconLixeiraListagem.446b8b90.svg";